export default {
    AsterMail: {
        getdata: []
    }
};